var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "row no-gutters mt-10 pl-container-align z-5 pr-sm-0 justify-content-sm-end justify-content-center",
      },
      [
        _c("div", { staticClass: "col-lg-10 col-14 text-sm-right" }, [
          _c(
            "div",
            { staticClass: "venue-carousel-filters mb-3" },
            _vm._l(_vm.categories, function (category, index) {
              return _c(
                "button",
                {
                  key: index,
                  class: { active: _vm.selectedCategory.id == category.id },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.selectCategory(category)
                    },
                  },
                },
                [_vm._v(_vm._s(category.title))]
              )
            }),
            0
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row no-gutters mb-10 pl-container-align z-5 pr-sm-0" },
      [
        _c(
          "div",
          { staticClass: "col-lg-6 text-justify mb-lg-0 mb-6 mx-sm-0 mx-4" },
          [_vm._t("text", null, { selectedCategory: _vm.selectedCategory })],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-10 ml-sm-0 ml-8" }, [
          _c(
            "div",
            { staticClass: "venue-carousel" },
            [
              _c(
                "slick",
                {
                  ref: "slick",
                  attrs: { options: _vm.options },
                  on: {
                    afterChange: _vm.handleAfterChange,
                    init: _vm.handleOnInit,
                  },
                },
                [_vm._t("slides")],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "venue-carousel-pagination" }, [
                _c("p", { staticClass: "page-current" }, [
                  _vm.currentSlide < 10 ? _c("span", [_vm._v("0")]) : _vm._e(),
                  _vm._v(_vm._s(_vm.currentSlide)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "page-length" }, [
                  _vm.slidesLength < 10 ? _c("span", [_vm._v("0")]) : _vm._e(),
                  _vm._v(_vm._s(_vm.slidesLength)),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "venue-carousel-nav" }, [
      _c("button", { staticClass: "slick-prev" }, [
        _c("i", { staticClass: "icon-arrow-medium-left icon-sm" }),
      ]),
      _vm._v(" "),
      _c("button", { staticClass: "slick-next" }, [
        _c("i", { staticClass: "icon-arrow-medium-right icon-sm" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }